import { useEffect, useState } from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import { getBlockedVideos, unblockVideo } from "../../services/APIServices/block.api";
import { useTranslation } from "react-i18next";

export default function BlockedVideos() {
     const [videos, setVideos] = useState<any[]>([]);
     const [loading, setLoading] = useState(true);
     const { t } = useTranslation();

     useEffect(() => {
          fetchVideos();
     }, []);

     const fetchVideos = async () => {
          try {
               const res = await getBlockedVideos();
               setVideos(res as any || []);
          } catch (err) {
               console.error(err);
          } finally {
               setLoading(false);
          }
     };

     const handleUnblock = async (id: string) => {
          try {
               await unblockVideo(id);
               setVideos((prevVideos) => prevVideos.filter((v) => v.blockedID !== id));
          } catch (err) {
               console.error(err);
          }
     };

     if (loading) return <Typography>Loading...</Typography>;

     if (videos.length === 0) {
          return (
               <Box sx={{ textAlign: "center", mt: 4 }}>
                    <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                         {t("blocked.blockedVideos")}
                    </Typography>
                    <Typography variant="h6">
                         {t("blocked.blockedVideosNone")}
                    </Typography>
               </Box>
          );
     }

     return (
          <Box sx={{ p: 2 }}>
               <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                    {t("blocked.blockedVideos")}
               </Typography>
               {videos.map(video => (
                    <Card
                         key={video.blockedID}
                         sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 2,
                              borderRadius: 3,
                              p: 1,
                         }}
                    >
                         <img
                              src={video.logoUrl}
                              alt={video.name}
                              style={{ width: 100, height: 60, borderRadius: 8, marginRight: 10 }}
                         />
                         <CardContent sx={{ flexGrow: 1, p: 1 }}>
                              <Typography variant="body1" fontWeight={500}
                                   noWrap
                                   sx={{
                                        maxWidth: {
                                             xs: "120px",
                                             sm: "200px",
                                             md: "250px",
                                        },
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                   }}>
                                   {video.name}
                              </Typography>
                         </CardContent>
                         <Button
                              variant="contained"
                              color="warning"
                              sx={{ borderRadius: 5, mr: 1 }}
                              onClick={() => handleUnblock(video.blockedID)}
                         >
                               {t("blocked.unblock")}
                         </Button>
                    </Card>
               ))}
          </Box>
     );
}